import { Component, Inject, OnInit } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'lean-confirmation',
  templateUrl: './lean-confirmation.component.html',
  styleUrls: ['./lean-confirmation.component.css']
})

export class LeanConfirmationComponent implements OnInit {

 title              : string  = "Confirmation";
 confirmationMessage: string  = "Confirmez-vous cette  opération ?";


  constructor(
    public dialogRef: MatDialogRef<LeanConfirmationComponent>,  @Inject(MAT_DIALOG_DATA) public data: any) { 
      if ((data) && (data.title) )               this.title = data.title;
      if ((data) && (data.confirmationMessage) ) this.confirmationMessage = data.confirmationMessage;
  }

  ngOnInit() {
  }

  validate() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }

}
